import React, { ChangeEvent } from 'react'
import { FieldNames, RecurrenceVariantTypes } from '../../../types/publishSchedule'
import { setFieldValue } from '../../../actions/publishSchedule'
import { getValueIfPositiveInteger } from '../../../services/publishSchedule'
import { usePublishSchedule } from '../hooks'
import {
  StyledTextField,
  StyledRadioGroup,
  StyledFormGroup,
  RecurrenceVariantsContainer,
  RecurrenceWeekdayContainer,
  StyledRadio,
  StyledFormControlLabel
} from '../styled'
import { GenericDropdown } from './GenericDropdown'

export const RecurrenceVariants = () => {
  const [{ fieldValues, fieldErrors }, dispatch] = usePublishSchedule()
  const disableWeekdayContainerFields = fieldValues.recurrenceVariant === RecurrenceVariantTypes.dayByNumber

  return (
    <RecurrenceVariantsContainer>
      <StyledRadioGroup
        aria-label={`${fieldValues.recurrenceDayNumber}-recurrence-options`}
        value={fieldValues.recurrenceVariant}
        onChange={(e: ChangeEvent<{}>, value: string) => {
          dispatch(setFieldValue(FieldNames.recurrenceVariant, value))
        }}
      >
        <StyledFormControlLabel
          value={RecurrenceVariantTypes.dayByNumber}
          control={<StyledRadio color="primary" />}
          label="Day"
        />
        <StyledFormControlLabel
          value={RecurrenceVariantTypes.dayByName}
          control={<StyledRadio color="primary" />}
          label="The"
        />
      </StyledRadioGroup>
      <StyledFormGroup>
        <StyledTextField
          id={`${fieldValues.recurrenceDayNumber}-day-number`}
          margin="dense"
          type="number"
          disabled={fieldValues.recurrenceVariant === RecurrenceVariantTypes.dayByName}
          value={fieldValues[FieldNames.recurrenceDayNumber] || ''}
          error={!!fieldErrors[FieldNames.recurrenceDayNumber]}
          helperText={fieldErrors[FieldNames.recurrenceDayNumber]}
          onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
            dispatch(setFieldValue(FieldNames.recurrenceDayNumber, getValueIfPositiveInteger(value)))
          }}
        />
        <RecurrenceWeekdayContainer>
          <GenericDropdown
            fieldName={FieldNames.recurrenceWeekdayCount}
            disabled={disableWeekdayContainerFields}
          />
          <GenericDropdown
            fieldName={FieldNames.recurrenceWeekday}
            disabled={disableWeekdayContainerFields}
          />
        </RecurrenceWeekdayContainer>
      </StyledFormGroup>
    </RecurrenceVariantsContainer>
  )
}
